import { RadialSeparatorProps } from '../../types';

/**
 * Renders a single radial separator tick around the score circle.
 */
export const RadialSeparator: React.FC<RadialSeparatorProps> = ({ opacity = 1, style, turns }) => {
  // The container div is rotated to position the separator correctly around the circle,
  // while the inner div applies the visual styling of the tick.
  const containerStyle: React.CSSProperties = {
    height: '100%',
    pointerEvents: 'none',
    position: 'absolute',
    transform: `rotate(${turns}turn)`,
  };

  // Apply opacity and transition to the tick for smooth fade in/out effects in pass/fail mode.
  const tickStyle: React.CSSProperties = {
    ...style,
    opacity,
    transition: 'opacity 120ms linear',
  };

  // Render
  return (
    <div style={containerStyle}>
      <div style={tickStyle} />
    </div>
  );
};

RadialSeparator.displayName = 'RadialSeparator';

export default RadialSeparator;
